<template>
  <detail-layout-three-columns-no-fixed-collapsible class="step-7" :toEdge="false" custom-left="md:w-11.5/12 lg:max-w-detailinvoice" custom-middle="lg:overflow-y-visible mr-4 lg:mr-10" :custom-right="summaryWidth" :collapsed="isCollapsed" @update:collapsed="collapse">
    <template slot="header">
      <slot name="header" />
      <div class="px-4 lg:px-10 font-medium dark:text-white mb-2 flex gap-4 items-center">
        <h2>{{ step.description }}</h2>
      </div>
    </template>
    <template slot="LeftCol">
      <invoice-new-attachment-dialog v-if="!check" :pgeType="form.pgeType" :mobile-version="isLower1024" :dialogOpen="showNewAttachment" :idFacturae="-1"
        :idInvoice="-1" @toggleDialog="toggleDialogAttachment" @applyDialog="applyDialogAttachmentHandler" />
      <div class="form-wrapper px-4 lg:px-10">
        <el-form ref="ruleForm" :model="form" :rules="rules" autocomplete="off">
          <div class="hideHScroll">
            <!-- #region Plantillas -->
            <div v-if="!check && hasModuleCustomXslt" class="flex flex-col lg:flex-row lg:mb-2 gap-x-6">
              <div class="w-full" >
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('plantilla_pdf.header') }}</label>
                <el-form-item prop="template" class="w-full">
                  <base-el-select 
                    class="w-full" 
                    :options="templateOptions" 
                    :option-key="(option) => option.idPlantilla" 
                    :option-value="(option) => option"
                    v-model="form.template" 
                    :loading="isTemplateLoading"
                    :disabled="isGeneralLoading || isTemplateLoading"
                    @change="onChangeTemplate" 
                    value-key="idPlantilla"
                    filterable 
                    clearable>
                  </base-el-select>
                </el-form-item>
              </div>
            </div>
            <!-- #endregion -->

            <div class="flex w-full">
              <div class="flex-1 w-full" :class="{ 'mt-5': hasModuleCustomXslt && !check }">
                <!-- #region Imagen principal -->
                <base-collapsible-form v-if="!check && !isInProformaIssuingType && !isInQuotationIssuingType" ref="fileCollapsible"
                  class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2"
                  @toggle="fileCollapsibleToggle">
                  <template slot="headerRight">
                    <div class="flex items-center gap-4 flex-1">
                      <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{ $t('invoices.invoices_issuing.imagen') }}</h4>
                      <el-form-item v-show="!isFileCollapsibleOpen" prop="file" class="flex-1">
                      </el-form-item>
                    </div>
                  </template>
                  <template slot="content">
                    <div>
                      <div class="flex -mx-2 flex-col lg:flex-row">
                        <div class="px-2 mb-2 lg:mb-0">
                          <el-form-item prop="file" ref="uploadfile">
                            <Upload
                              ref="upload"
                              id="pfxselector"
                              class="bg-white dark:bg-darkblue-900"
                              :class="uploadClass"
                              drag
                              action="#"
                              accept="application/pdf"
                              :file-list="form.file"
                              :limit=1
                              :multiple="false"
                              :auto-upload=false
                              :disabled="check || isGeneralLoading"
                              :on-remove="handleRemove"
                              :on-change="handleChange"
                              :on-exceed="handleOnExceed">
                              <i class="el-icon-upload"></i>
                              <p v-if="form.file.length" slot="default" class="el-upload__text"><em>{{ formFile.name }}</em></p>
                              <div v-else slot="default" class="el-upload__text" v-html="$tc('app.upload_default_no_file_text', 1)"></div>
                              <upload-file-item slot="file" slot-scope="{file}" :file="file" hide-status
                                hide-expand-action custom="!max-h-fit" @remove="handleRemove" reverse-colors />
                            </Upload>
                          </el-form-item>
                        </div>
                      </div>
                    </div>
                  </template>
                </base-collapsible-form>
                <!-- #endregion -->


                <!-- #region Documentos de factura -->
                <div class="lg:mb-4" :class="{ 'mt-8': !check }">
                  <h3 class="dark:text-darkblue-200 font-bold mb-2" :class="{ 'mt-4': !check }">{{ $t('invoices.invoices_documents') }}</h3>
                  <el-table ref="documentos" :data="attachments" style="width: 100%" :empty-text="$t('app.no_data_text')"
                    :show-header="form.Adjuntos && form.Adjuntos.length > 0">
                    <el-table-column prop="tipo" width="36" align="center">
                      <template slot-scope="tipos">
                        <el-tooltip v-if="tipos.row.tipo" placement="left">
                          <div slot="content">
                            <div class="max-w-sm max-h-500p overflow-auto">
                              <div v-if="tipos.row.tipo === 'xml'">{{ $t('invoices.xml_invoice') }}</div>
                              <div v-else>{{ $t('invoices.document_adj_emb_long') }}</div>
                            </div>
                          </div>
                          <base-icon :name="tipos.row.tipo" />
                        </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column prop="Nombre" :label="$tc('app.documents', 1)" min-width="200" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="actions" width="180" align="center" :label="$tc('app.actions', 2)">
                      <template slot-scope="adjuntos">
                        <div class="flex flex-row" :hidden="adjuntos.row.loading">
                          <base-button-icon v-if="adjuntos.row.icon === 'eye' || adjuntos.row.icon === 'eyeslash'"
                            class="mr-2" @click="showAdjunto(adjuntos.row, true)" :name="adjuntos.row.icon" mode="core" :disabled="isGeneralLoading" />
                          <base-button-icon @click="downloadAdjunto(adjuntos.row, false)" name="download" mode="core" :disabled="isGeneralLoading" />
                          <base-button-icon @click="printAdjunto(adjuntos.row, false)" name="printer" mode="core" :disabled="isGeneralLoading" />
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column v-if="!isLower1650" prop="Extension" :label="$t('app.extension')" width="90">
                    </el-table-column>
                    <el-table-column v-if="!check" prop="actions" width="64" label="">
                      <template slot-scope="scope">
                        <base-button-icon @click="deleteAdjunto(scope.row, false)" name="trash" mode="core" :loading="scope.row.loading" :disabled="scope.row.loading || isGeneralLoading"/>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div v-if="isInInvoicesIssuingType || isInSimplifiedIssuingType" class="w-full m-2 float-right">
                    <base-button-responsive mode="primary" v-if="!check" :text="$t('app.new_document')"
                      @click="toggleDialogAttachment" icon="plus" class="m-5 float-right" />
                  </div>
                </div>
                <!-- #endregion -->

              </div>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="MiddleCol">
      <div v-show="showDocument" :class="{ 'h-screen': showPdf }"
        class="document-visor bg-primary-50 dark:bg-darkblue-800 dark:text-darkblue-200 xl:inline-block relative w-full flex-grow hideHScroll lg:h-full divide-y-2 divide-blue-200 dark:divide-gray-800">
        <div class=" loader contained" v-if="isFileLoading" >
          <loading :opacity="0" :active.sync="isFileLoading" color="var(--primary-DEFAULT)"></loading>
        </div>
        <img v-if="!showXhtml && !showPdf && showImage" :src="srcImage" class="m-auto">
        <PDFViewerApp v-show="!showXhtml && showPdf && !showImage" :search="actualFilterContent"
          @pdfViewerOpenHandler="pdfViewerOpenHandler" :pdf="url" :name="viewerFilename" />
        <div v-if="showXhtml" class="w-full h-full p-2 iframe-xhtml">
          <iframe id="container-xhtml-iframe" class="w-full p-2 iframe-xhtml" scrolling="auto" ref="frame">
          </iframe>
        </div>
      </div>
    </template>
    <template slot="RightCol">
      <slot name="invoice-summary" />
    </template>
    <template slot="layout-extend">
      <slot name="layout-extend" :valid="hasFile" :loading="isLoading" />
    </template>
  </detail-layout-three-columns-no-fixed-collapsible>
</template>

<script>
import { i18n } from '@/i18n'
import { getPlantillasImagenCompany } from '@/services/companies/getPlantillasImagenCompany'
import { getPDF } from '@/services/configurations/getPDF'
import { getPDFSimplificada } from '@/services/configurations/getPDFSimplificada'
import { getPDFProformaPresupuesto } from '@/services/configurations/getPDFProformaPresupuesto'
import getPayloadFacturae from '@/services/functions/getPayloadFacturae'
import getPayloadSimplificada from '@/services/functions/getPayloadSimplificada'
import DetailLayoutThreeColumnsNoFixedCollapsible from '@/components/layout/DetailLayoutThreeColumnsNoFixedCollapsible.vue'
import InvoiceNewAttachmentDialog from '@/components/InvoiceNewAttachmentDialog.vue'
import UploadFileItem from '@/components/UploadFileItem.vue'
import PDFViewerApp from '@/components/pdf/PDFViewerApp.vue'
import Loading from 'vue-loading-overlay'
import { Upload } from 'element-ui'

import icons from '@/components/icons/_iconLibrary'
import { mapGetters } from 'vuex'

export default {
  name: 'step7-attachments',
  components: {
    Loading,
    PDFViewerApp,
    DetailLayoutThreeColumnsNoFixedCollapsible,
    InvoiceNewAttachmentDialog,
    UploadFileItem,
    Upload,
  },
  props: {
    step: Object,
    value: [Number, String],
    isFirstStep: {
      type: Boolean,
      default: false
    },
    check: {
      type: Boolean,
      default: false
    },
    summaryWidth: {
      type: [Array, Object, String],
      default: 'w-full'
    },
    collapsed: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      stepId: '7',
      // All
      showNewAttachment: false,
      vuexnamespace: 'invoicesIssuing/7',
      showPdf: false,
      actualFilterContent: null,
      showXhtml: '',
      showImage: '',
      url: '',
      viewerFilename: '',
      isFileCollapsibleOpen: false,
      isFileLoading: false,
      isTemplateLoading: false,
      isCollapsed: false,
      isCollapsedByFile: false,
      templateOptions: [],
      rules: {
        template: [
          {
            required: true,
            message: i18n.t('validation.complete'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (!this.form.template && this.form.file.length < 0) {
                callback(new Error(i18n.t('validation.complete')))
              } else if (this.form.file.length > 0) {
                callback()
              } else {
                callback()
              }
            }
          }
        ],
        file: [
          {
            message: i18n.t('validation.complete'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if ((!this.hasModuleCustomXslt || !this.form.template) && !this.formFile.name) {
                callback(new Error(i18n.t('validation.complete')))
              } else {
                callback()
              }
            }
          },
          {
            message: i18n.t('validation.not_single_valid_extension', { ext: '.pdf' }),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.formFile.name && 
                (this.formFile.name.length < 5 || 
                (this.getExtensionFromFile(this.formFile.name).toUpperCase() !== 'PDF'))
              ) {
                callback(new Error(i18n.t('validation.not_single_valid_extension', { ext: '.pdf' })))
              } else {
                callback()
              }
            }
          },
          {
            message: i18n.t('validation.exceed_size_files') + ' (1 MB)',
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.formFile.name && this.formFile.bytes &&
                this.formFile.bytes.size > this.maxSizeFile) {
                callback(new Error(i18n.t('validation.exceed_size_files')))
              } else {
                callback()
              }
            }
          },
        ],
      }
    }
  },
  created () {
    this.isCollapsed = this.collapsed
    if (this.hasModuleCustomXslt && this.form.template !== '') {
      this.isTemplateLoading = true
      this.templateOptions = [this.form.template]
      this.mainFile.loading = true
    }
  },
  async mounted () {
    if (this.hasModuleCustomXslt) {
      this.isTemplateLoading = true
      if (this.form.template !== '') {
        this.mainFile.loading = true
      }
      this.templateOptions = await this.getTemplatePDF()
      if (this.form.template !== '') {
        this.form.template.url = undefined
        await this.onChangeTemplate(this.form.template)
        this.mainFile.loading = false
      }
      this.isTemplateLoading = false
    } else {
      this.$refs.fileCollapsible.toggle()
      this.templateOptions = []
      this.form.template = ''
    }
  },
  watch: {
    showXhtml: function (value, oldValue) {
      if (value) {
        setTimeout(() => {
          this.insertIframeContent()
        }, 200)
      }
    },
  },
  computed: {
    ...mapGetters('invoicesIssuing', ['issuingType', 'issuingTypeStr', 'isInIssuingType']),
    isInInvoicesIssuingType: function () {
      return this.isInIssuingType(1)
    },
    isInSimplifiedIssuingType: function () {
      return this.isInIssuingType(4)
    },
    form: function () {
      return this.$store.getters[this.vuexnamespace + '/form']
    },
    finalForm: function () {
      return this.$store.getters['invoicesIssuing/form']
    },
    formFile: function () {
      return this.form.file[0] || ''
    },
    mainFile: function () {
      const file = this.formFile
      if (file && file.name) {
        return this.formatFile(file)
      }
      if (this.form.template) {
        return this.formatTemplate(this.form.template)
      }
      return null
    },
    attachments: function () {
      return [this.mainFile, ...this.form.Adjuntos].filter(x => x)
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    hasModuleCustomXslt () {
      return this.$store.getters['auth/hasXsltModule']
    },
    hasFile: function () {
      return !!(this.formFile || this.form.template)
    },
    showDocument: function () {
      return !!(this.showXhtml || this.showPdf || this.showImage)
    },
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    isLower1650: function () {
      return this.$store.getters['app/getIsLower1650']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading || this.isFileLoading
    },
    isLoading: function () {
      return this.isFileLoading || this.isTemplateLoading
    },
    uploadClass: function () {
      return { 'custom-upload-cert': this.isLower1024, 'custom-upload': !this.isLower1024 }
    },
    isInProformaIssuingType: function () {
      return this.isInIssuingType(2)
    },
    isInQuotationIssuingType: function () {
      return this.isInIssuingType(3)
    },
  },
  methods: {
    fileCollapsibleToggle: function (isOpen) {
      this.isFileCollapsibleOpen = isOpen
    },
    validate: function (callback = (valid) => {}, doInput = true) {
      this.$refs.ruleForm.validate(valid => {
        if (valid && doInput && (this.isFirstStep || this.value === '') && [3, 7, 8].includes(this.role)) {
          this.$emit('input', this.selected[0]?.idCliente ?? '')
        }
        callback(valid) 
      })
    },
    resetForm (excluded = []) {
      if (!this.check && !excluded.includes(this.stepId)) {
        this.$store.dispatch(this.vuexnamespace + '/resetForm')
      }
    },
    pdfViewerOpenHandler () {
      this.actualFilterContent = null
    },
    getTemplatePDF: async function () {
      this.isTemplateLoading = true
      const params = { idCIFEmpresa: this.finalForm.issuer.IdCIFEmpresa, selectInherit: true }
      const data = await getPlantillasImagenCompany(params)
      if (data.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
      }
      if (!this.formFile && !this.form.template && data.Respuesta?.config?.PlantillaActiva) {
        this.form.template = data.Respuesta.config.PlantillaActiva
      }
      this.isTemplateLoading = false
      return data.Respuesta.templates || []
    },
    onChangeTemplate: async function (template) {
      try {
        if (this.mainFile) {
          this.mainFile.loading = true
          if (this.mainFile.visible) {
            this.isFileLoading = true
          }
        }
        this.$nextTick(() => {
          if (this.mainFile) {
            this.mainFile.loading = true
            this.isFileLoading = true
          }
        })
        if (template !== '') {
          this.$store.commit('setIsLoading', true)
          this.resetDocumentsSelected()
          if (template.url === undefined) {
            const params = { idCIFEmpresa: this.finalForm.issuer.IdCIFEmpresa }
            let response = null
            if (this.isInSimplifiedIssuingType) {
              const payload = await getPayloadSimplificada(this.finalForm, { includeFiles: false, overrideTemplate: template })
              response = await getPDFSimplificada(payload, params)
            } else {
              const payload = await getPayloadFacturae(this.finalForm, { includeFiles: false, overrideTemplate: template })
              if (this.isInInvoicesIssuingType) {
                response = await getPDF(payload, params)
              } else {
                params.typeInvoice = this.issuingTypeStr
                response = await getPDFProformaPresupuesto(payload, params)
              } 
            }
            const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
            this.$set(template, 'url', window.URL.createObjectURL(blob))
          }
          this.$nextTick(() => {
            this.isFileLoading = true
            this.showAdjunto(this.mainFile)
            this.isFileLoading = false
          })
          this.form.file = []
        } else {
          if (this.mainFile.visible) {
            this.showAdjunto(this.mainFile)
            this.isFileLoading = false
          }
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        if (this.mainFile) {
          this.mainFile.loading = false
        }
        this.isFileLoading = false
      }
    },
    applyDialogAttachmentHandler: function (file) {
      this.form.Adjuntos.push(...file.map(x => this.formatFile(x)))
      // const docRel = false
      // const exceptionDocument = {
      //   docRel,
      //   idRelatedDocument: null,
      // }
      // this.resetDocumentsSelected(exceptionDocument)
      this.showAdjunto(this.form.Adjuntos[this.form.Adjuntos.length-1], true)
    },
    printDocument: function () {},
    showAdjunto: async function (row, withoutEvent) {
      const docRel = false
      const exceptionDocument = {
        docRel,
        idRelatedDocument: row.idRelatedDocument,
      }
      this.resetDocumentsSelected(exceptionDocument)
      if (row.Extension.trim().toUpperCase() === 'PDF') {
        this.showXhtml = false
        if (row.icon === 'eye') {
          row.icon = 'eyeslash'
          row.visible = true
          this.showPdf = true
          this.attachments.filter(x => x.uid !== row.uid).forEach(x => {
            x.visible = false
            x.icon = ['eye', 'eyeslash'].includes(x.icon) ? 'eye' : 'download'
          })
          this.isCollapsedByFile = !this.isCollapsed || this.isCollapsedByFile
          this.isCollapsed = true
        } else {
          row.icon = 'eye'
          row.visible = false
          this.showPdf = false
          this.isCollapsed = !this.isCollapsedByFile
          this.isCollapsedByFile = false
        }
        this.resetRowName(row)
        await this.showPDFHandler(row, withoutEvent, docRel)
      } else {
        await this.downloadAdjunto(row, docRel)
      }
    },
    toggleDialogAttachment () {
      this.showNewAttachment = !this.showNewAttachment
    },
    downloadAdjunto: async function (row, docRel = false) {
      try {
        this.$store.commit('setIsLoading', true)
        row.loading = true
        var blob, url
        if (!row.url) {
          if (row.raw) {
            blob = row.raw
          } else if (row.b64) {
            blob = new Blob([row.b64], {
              type: 'application/pdf'
            })
          }
          url = URL.createObjectURL(blob)
        } else {
          url = row.url
        }
        const link = document.createElement('a')
        link.href = url
        // const headerVal = response.headers['content-disposition']
        let filename = row.Nombre.trim()
        if (!filename.endsWith('.' + row.Extension.trim())) {
          filename += '.' + row.Extension.trim()
        }
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('setIsLoading', false)
        row.loading = false
      }
    },
    printAdjunto: async function (row, docRel = false) {
      try {
        this.$store.commit('setIsLoading', true)
        row.loading = true
        var blob, url
        if (!row.url) {
          if (row.raw) {
            blob = row.raw
          } else if (row.b64) {
            blob = new Blob([row.b64], {
              type: 'application/pdf'
            })
          }
          url = URL.createObjectURL(blob)
        } else {
          url = row.url
        }

        var iframe = document.getElementById('printeriframe')
        if (iframe) iframe.remove()
        iframe = document.createElement('iframe')
        iframe.setAttribute('id', 'printeriframe')
        iframe.style.display = 'none'
        document.body.appendChild(iframe)
        iframe.onload = function () {
          iframe.focus()
          iframe.contentWindow.print()
          // iframe.remove()
        }
        iframe.src = url
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('setIsLoading', false)
        row.loading = false
      }
    },
    deleteAdjunto: function (row, docRel = false) {
      this.$store.commit('setIsLoading', true)
      row.loading = true
      if (Object.hasOwnProperty.call(row, 'idPlantilla')) {
        this.form.template = ''
      } else if (this.formFile.uid === row.uid) {
        this.form.file = []
      } else {
        this.form.Adjuntos = this.form.Adjuntos.filter(x => x.uid !== row.uid)
      }
      this.resetDocumentsSelected()
      this.showPdf = false
      this.$store.commit('setIsLoading', false)
      row.loading = false
    },
    showPDFHandler: async function (row, withoutEvent = false, docRel = false) {
      try {
        this.$store.commit('setIsLoading', true)
        var blob, url
        if (!row.url) {
          if (row.raw) {
            blob = row.raw
          } else if (row.b64) {
            blob = new Blob([row.b64], {
              type: 'application/pdf'
            })
          }
          url = URL.createObjectURL(blob)
        } else {
          url = row.url
        }
        this.url = url
        this.viewerFilename = decodeURI(row.Nombre).trim()
        // window.open(url)
      } catch (error) {
        this.doFeedback(i18n.t('feedback.error.download_file_error'))
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    handleOnExceed: function () {
      this.doFeedback(i18n.t('validation.max_files_warn', { limit: 1 }), 'warning')
    },
    handleChange: function (file) {
      this.$refs.uploadfile.clearValidate()
      this.resetDocumentsSelected()
      if (file) {
        this.form.file.push(this.formatFile(file))
        this.form.template = ''
        this.$nextTick(() => this.showAdjunto(this.mainFile))
      } else {
        this.form.file = []
      }
    },
    handleRemove: function (file) {
      this.showPdf = false
      this.form.file = this.form.file.filter(x => x.uid !== file.uid)
    },
    resetRowName (row) {
      // Tmp update icon
      const auxNombre = row.Nombre
      row.Nombre = auxNombre + ' '
      setTimeout(() => {
        row.Nombre = auxNombre
      }, 50)
    },
    resetDocumentsSelected: async function (rowException = null) {
      this.attachments.forEach(key => {
        // Resetea si no es el actual
        if (!rowException || !(!rowException.docRel && rowException.idRelatedDocument === key.idRelatedDocument)) {
          key.visible = false
          if (key.idRelatedDocument === 0 && key.Extension.trim().toUpperCase() === 'PDF') {
            key.icon = 'eye'
            key.tipo = 'pdf'
          } else {
            key.icon = key.Extension.trim().toUpperCase() === 'PDF' || key.Extension.trim().toUpperCase() === 'PNG' ? 'eye' : 'download'
            key.tipo = key.Relacionado ? 'xmlembed' : (icons.includes(key.Extension.trim().toLowerCase()) ? key.Extension.trim().toLowerCase() : 'docblack')
          }
        }
      })
    },
    formatTemplate (template) {
      var name = []
      if (this.finalForm.numFactura !== '') {
        name.push(this.finalForm.numFactura)
      }
      if ((this.finalForm.issuer?.CIF ?? '') !== '') {
        name.push(this.finalForm.issuer.CIF)
      }
      if (this.finalForm.dateEmision !== '') {
        const date = new Date(this.finalForm.dateEmision)
        if (!Number.isNaN(date.getTime())) {
          name.push(date.getFullYear())
        }
      }
      const finalName = name.length ? name.join('_') : 'factura'
      return {
        ...template,
        Nombre: `${finalName}.pdf`,
        tipo: 'pdf',
        Extension: 'pdf',
        icon: 'eye',
        loading: false,
        visible: false
      }
    },
    formatFile (file, ppaldoc = false) {
      return {
        ...file, 
        Nombre: file.Nombre || file.name,
        tipo: file.tipo || file.name.split('.').at(-1),
        Extension: file.Extension || file.name.split('.').at(-1),
        icon: file.icon || ['pdf', 'png', 'jpg'].includes(file.name.split('.').at(-1)) ? 'eye' : 'download',
        loading: false,
        visible: file.visible || false 
      }
    },
    collapse: function (collapsed) {
      this.isCollapsed = collapsed
      if (!this.isCollapsedByFile) {
        this.$emit('update:collapsed', collapsed)
      }
    }
  },
}
</script>
<style scoped lang="scss">

</style>
<style>
.hideHScroll {
  overflow-x: hidden;
}
</style>
